import React from 'react';
import {
  Box, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon,
  BottomNavigation, BottomNavigationAction
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TimerIcon from '@mui/icons-material/Timer';
import EventIcon from '@mui/icons-material/Event';
import PaymentIcon from '@mui/icons-material/Payment';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate, useLocation } from 'react-router-dom';
import { modernTheme } from './theme';

const DesktopSpeedDial = ({ onOpenAdvancePayment }) => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: <TimerIcon sx={{ color: modernTheme.colors.primary }} />,
      name: 'Chấm công nhanh',
      onClick: () => {
        document.getElementById('hours-input')?.focus();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      icon: <EventIcon sx={{ color: modernTheme.colors.secondary }} />,
      name: 'Đăng ký ca',
      onClick: () => navigate('/dashboard/schedule'),
    },
    {
      icon: <PaymentIcon sx={{ color: modernTheme.colors.accent }} />,
      name: 'Ứng tiền',
      onClick: onOpenAdvancePayment,
    },
    {
      icon: <HistoryIcon sx={{ color: modernTheme.colors.warning }} />,
      name: 'Lịch sử',
      onClick: () => navigate('/dashboard/history'),
    },
  ];

  return (
    <SpeedDial
      ariaLabel="Quick Actions"
      sx={{
        position: 'fixed', bottom: 24, right: 24,
        '& .MuiFab-primary': {
          background: modernTheme.gradients.primary,
          boxShadow: '0 8px 32px rgba(37, 99, 235, 0.4)',
          '&:hover': { background: modernTheme.gradients.primary, transform: 'scale(1.05)' },
        },
      }}
      icon={<SpeedDialIcon openIcon={<CloseIcon />} />}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          onClick={action.onClick}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              whiteSpace: 'nowrap',
              bgcolor: modernTheme.colors.gray[900],
              color: 'white', fontWeight: 600, fontSize: '0.8rem',
              borderRadius: 2,
            },
          }}
        />
      ))}
    </SpeedDial>
  );
};

const MobileBottomNav = ({ onOpenProfile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentIdx =
    location.pathname === '/dashboard' ? 0 :
    location.pathname === '/dashboard/history' ? 1 :
    location.pathname === '/dashboard/schedule' ? 2 : 3;

  const NavIcon = ({ icon: Icon, active, gradient }) => (
    <Box sx={{
      p: 0.75, borderRadius: 2,
      background: active ? gradient : 'transparent',
      transition: 'all 0.2s ease',
    }}>
      <Icon sx={{
        color: active ? 'white' : modernTheme.colors.gray[400],
        fontSize: 22, transition: 'all 0.2s ease',
      }} />
    </Box>
  );

  return (
    <>
      <Paper
        sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1200,
          borderRadius: '20px 20px 0 0',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.08)',
          overflow: 'hidden',
          background: 'rgba(255,255,255,0.97)',
          backdropFilter: 'blur(20px)',
          borderTop: `1px solid ${modernTheme.colors.gray[200]}`,
        }}
        elevation={0}
      >
        <BottomNavigation
          showLabels
          value={currentIdx}
          onChange={(_, newValue) => {
            const routes = ['/dashboard', '/dashboard/history', '/dashboard/schedule', null];
            if (newValue === 3) onOpenProfile();
            else navigate(routes[newValue]);
          }}
          sx={{
            height: 68, pb: 1,
            '& .MuiBottomNavigationAction-root': {
              minWidth: 'auto', padding: '6px 12px', gap: 0.25,
              transition: 'all 0.2s ease',
              '&.Mui-selected .MuiSvgIcon-root': { transform: 'scale(1.1)' },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.65rem', fontWeight: 600,
              '&.Mui-selected': { fontSize: '0.65rem' },
            },
          }}
        >
          <BottomNavigationAction label="Trang chủ"
            icon={<NavIcon icon={HomeIcon} active={currentIdx === 0} gradient={modernTheme.gradients.primary} />}
            sx={{ color: currentIdx === 0 ? modernTheme.colors.primary : modernTheme.colors.gray[500] }}
          />
          <BottomNavigationAction label="Lịch sử"
            icon={<NavIcon icon={HistoryIcon} active={currentIdx === 1} gradient={modernTheme.gradients.secondary} />}
            sx={{ color: currentIdx === 1 ? modernTheme.colors.secondary : modernTheme.colors.gray[500] }}
          />
          <BottomNavigationAction label="Đăng ký"
            icon={<NavIcon icon={EventIcon} active={currentIdx === 2} gradient={modernTheme.gradients.accent} />}
            sx={{ color: currentIdx === 2 ? modernTheme.colors.accent : modernTheme.colors.gray[500] }}
          />
          <BottomNavigationAction label="Cá nhân"
            icon={<NavIcon icon={PersonIcon} active={false} gradient="transparent" />}
            sx={{ color: modernTheme.colors.gray[500] }}
          />
        </BottomNavigation>
      </Paper>
      <Box sx={{ height: 76 }} />
    </>
  );
};

const QuickActions = ({ isMobile, onOpenAdvancePayment, onOpenProfile }) => {
  if (isMobile) {
    return <MobileBottomNav onOpenProfile={onOpenProfile} />;
  }
  return <DesktopSpeedDial onOpenAdvancePayment={onOpenAdvancePayment} />;
};

export default QuickActions;
